class CustomProductAsVariant extends HTMLElement {
  constructor() {
    super();
    this.variantUrl = this.dataset.variantUrl;
    this.sectionId = this.dataset.sectionId;
    this.addEventListener("click", this.onVariantClick);
  }

  onVariantClick() {
    fetch(this.variantUrl)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const mainContentDestinationEl = document.querySelector("#MainContent");
        const mainContentSourceEl = html.querySelector("#MainContent");
        if (mainContentDestinationEl && mainContentSourceEl) {
          mainContentDestinationEl.innerHTML = mainContentSourceEl.innerHTML
        }
      })
      .catch((error)=>{
        console.error('Error fetching data:', error);
      });
    this.updateUrl();
  }

  updateUrl() {
    window.history.replaceState({}, "", `${this.variantUrl}`);
  }
}

customElements.define("custom-product-as-variant", CustomProductAsVariant);
